"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SortImg = _interopRequireDefault(require("../../store/creatStore/modules/SortImg.vue"));
var _validate = require("@/utils/validate");
var pintuanApi = _interopRequireWildcard(require("@/api/pintuanApi"));
var _logistics = require("@/api/logistics");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    SortImgVue: _SortImg.default
  },
  data: function data() {
    return {
      shippingList: [],
      ruleForm: {
        images: [],
        logisticsType: [],
        activeRange: []
      },
      loading: false,
      details: {},
      mealImg: '',
      selectIds: [],
      skuLists: []
    };
  },
  mounted: function mounted() {
    var _this2 = this;
    var _this$$route$params = this.$route.params,
      id = _this$$route$params.id,
      isDisabled = _this$$route$params.isDisabled,
      spuid = _this$$route$params.spuid;
    this.ruleForm = {};
    this.details = {};
    this.shippingList = [];
    (0, _logistics.shippingTemplatesList)().then(function (res) {
      _this2.shippingList = res.list || [];
    });
    if (id && id != 0 || spuid && spuid != 0) {
      this.getSpecDetail(id, spuid);
    }
    ;
  },
  methods: {
    changeSliderImages: function changeSliderImages(data) {
      this.ruleForm.images = data;
    },
    upLoadSliderImages: function upLoadSliderImages() {
      var _this = this;
      this.$modalUpload(function () {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        data.forEach(function (v) {
          var _this$ruleForm, _this$ruleForm$images;
          if ((_this$ruleForm = _this.ruleForm) !== null && _this$ruleForm !== void 0 && (_this$ruleForm$images = _this$ruleForm.images) !== null && _this$ruleForm$images !== void 0 && _this$ruleForm$images.length) {
            _this.ruleForm.images.push(v.sattDir);
          } else {
            _this.ruleForm.images = [v.sattDir];
          }
        });
      }, 'duo');
    },
    // 提交保存
    handerSubmit: function handerSubmit(form) {
      var _this3 = this;
      this.$refs[form].validate(function (valid) {
        var _this3$selectIds, _this3$details;
        if (!valid) return;
        if (!((_this3$selectIds = _this3.selectIds) !== null && _this3$selectIds !== void 0 && _this3$selectIds.length)) {
          return _this3.$message.warning('请选择规格！');
        }
        ;
        _this3.loading = true;
        pintuanApi[(_this3$details = _this3.details) !== null && _this3$details !== void 0 && _this3$details.id ? 'editPinGoods' : 'savePinGoods'](_objectSpread(_objectSpread({}, _this3.ruleForm), {}, {
          image: _this3.mealImg,
          selectIds: _this3.selectIds
        })).then(function (data) {
          _this3.$message.success('操作成功');
          _this3.loading = false;
          _this3.goReturn();
        }).catch(function () {
          _this3.loading = false;
        });
      });
    },
    // 获取详情
    getSpecDetail: function getSpecDetail(id, spuid) {
      var _this4 = this;
      var detialId = id && id != 0 ? id : spuid;
      if (!detialId || detialId == 0) return;
      pintuanApi[id && id != 0 ? 'getPinGoodsDetial' : 'initPinGoods'](detialId).then(function (res) {
        _this4.details = JSON.parse(JSON.stringify(res));
        var _ref = res || {},
          image = _ref.image,
          images = _ref.images,
          startTime = _ref.startTime,
          endTime = _ref.endTime,
          logisticsType = _ref.logisticsType,
          _ref$attrValues = _ref.attrValues,
          attrValues = _ref$attrValues === void 0 ? [] : _ref$attrValues,
          _ref$skuList = _ref.skuList,
          skuList = _ref$skuList === void 0 ? [] : _ref$skuList;
        _this4.mealImg = image;
        _this4.skuLists = attrValues === null || attrValues === void 0 ? void 0 : attrValues.map(function (item) {
          var data = _objectSpread({}, item);
          var idx = skuList === null || skuList === void 0 ? void 0 : skuList.findIndex(function (v) {
            return v.skuId == item.id;
          });
          if (idx >= 0) {
            var _skuList$idx, _skuList$idx2, _this4$selectIds;
            data = _objectSpread(_objectSpread({}, data), {}, {
              num: (_skuList$idx = skuList[idx]) === null || _skuList$idx === void 0 ? void 0 : _skuList$idx.num,
              defaultPrice: (_skuList$idx2 = skuList[idx]) === null || _skuList$idx2 === void 0 ? void 0 : _skuList$idx2.defaultPrice
            });
            (_this4$selectIds = _this4.selectIds) === null || _this4$selectIds === void 0 ? void 0 : _this4$selectIds.push(data);
            setTimeout(function () {
              _this4.$refs.tableListRef.toggleRowSelection(data);
            }, 100);
          }
          ;
          return data;
        });
        _this4.ruleForm = _objectSpread(_objectSpread({}, res), {}, {
          images: images && JSON.parse(images),
          activeRange: startTime && endTime ? [startTime, endTime] : [],
          logisticsType: (logisticsType === null || logisticsType === void 0 ? void 0 : logisticsType.split(',')) || []
        });
      });
    },
    // 返回列表
    goReturn: function goReturn() {
      this.$router.push('/store/goodsManage/pintuanSpu');
    },
    //上传图片
    modalPicTap: function modalPicTap(tit) {
      var _this5 = this;
      this.$modalUpload(function (img) {
        _this5.mealImg = img[0].sattDir;
      }, tit, 'system');
    },
    removeImg: function removeImg() {
      this.mealImg = '';
    },
    // // 多选框选中数据
    handleSelectionChange: function handleSelectionChange() {
      var selection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.selectIds = selection;
    }
  }
};